<template>
    <div class="m-index-panel index-panel">
        <ALettersIndex
            v-model="activeLetter"
            :active-buttons="activeButtons"
            @onClick="handleClick($event)"
        />
    </div>
</template>

<script>
import ALettersIndex from '../../atoms/a-letters-index/a-letters-index';

export default {
    name: 'MIndexPanel',
    components: {
        ALettersIndex
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        activeButtons: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        activeLetter: 'a'
    }),
    watch: {
        value(value) {
            this.activeLetter = value
        }
    },
    /*computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },*/
    methods: {
        handleClick(evt) {
            this.$emit('clickLetter', evt);
            this.$emit('input', evt);
        }
    }
}
</script>

<style lang="scss">
@import "m-index-panel";   
</style>